import {Component, Inject, OnDestroy, OnInit, PLATFORM_ID, ViewChild} from '@angular/core';
import {CoinService} from '../../../../../common/services/coin.service';
import {ToastrService} from 'ngx-toastr';
import {Router} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {DOCUMENT} from '@angular/common';
import {ScriptsService} from '../../../../../common/services/scripts.service';
import {UploadImageComponent} from '../../../../../common/components/upload-image/upload-image.component';
declare var $: any;

@Component({
  selector: 'app-add-coin',
  templateUrl: './add-coin.component.html',
  styleUrls: ['./add-coin.component.css']
})
export class AddCoinComponent implements OnInit, OnDestroy {

  coin: any = {
    name: null,
    description: null,
    symbol: null,
    network: null,
    social: {
      telegram: null,
      twitter: null,
      discord: null,
      website: null
    },
    contract: null,
    launch: null,
    image: null,
    logo: null
  };
  fileToUpload: any;
  lastenter: any;

  saveCoin: any;

  submitted = false;
  loading = false;

  networks: any = [
    {value: 'eth', name: 'Ethereum'},
    {value: 'bsc', name: 'BSC'},
    {value: 'solana', name: 'Solana'},
    {value: 'sui', name: 'SUI'},
    {value: 'base', name: 'Base'},
    {value: 'arb', name: 'Arbitrum'},
    {value: 'mvx', name: 'MultiversX'},
    {value: 'op', name: 'Optimism'},
    {value: 'polygon', name: 'Polygon (MATIC)'},
    {value: 'tron', name: 'TRON'},
    {value: 'algorand', name: 'Algorand'},
    {value: 'harmony', name: 'Harmony'}
  ];

// {value: 'cardano', name: 'Cardano'}

  @ViewChild(UploadImageComponent, {static: true})
  private uploadImage: UploadImageComponent | undefined;

  constructor(
    private coinService: CoinService,
    private toastr: ToastrService,
    private router: Router,
    private titleService: Title,
    private scriptSercice: ScriptsService,
    @Inject(DOCUMENT) private _document: any,
    @Inject(PLATFORM_ID) private _platformId: any
  ) {
    this.titleService.setTitle('Add coin - CoinCatapult');
  }

  ngOnInit() {
    // this._document.body.classList.add('recaptcha');
    // this.scriptSercice.load('recaptcha').then(data => {
    // }).catch((error: any) => console.log(error));
  }

  save(form: any) {
    if (this.loading) {
      return;
    }
    this.loading = true;
    this.submitted = true;
    if (!form.valid) {
      this.loading = false;
      return;
    }
    this.submitted = false;

    this.saveCoin = this.coinService.saveObject(this.coin)
      .subscribe(
        (data: any) => {
          if (data.response) {
            this.submitted = false;
            this.loading = false;
            this.router.navigate(['/coin/' + data.response.slug]);
          } else {
            this.loading = false;
            this.toastr.error(data.error_code.message);
          }

        },
        (error: any) => {
          this.loading = false;
          this.toastr.error(error);
        });
  }

  openFilepload() {
    const uploadSinglePdf = document.getElementById('uploadSingle') as HTMLElement;
    uploadSinglePdf.click();
  }

  public fileDropOverPdf(event: any) {
    event.stopPropagation();
    event.preventDefault();
    $('#dragAndDrop').addClass('uploading');

  }

  public mouseDragLeavePdf(event: any) {
    event.stopPropagation();
    event.preventDefault();
    if (this.lastenter === event.target) {
      $('#dragAndDrop').removeClass('uploading');
    }
  }

  public mouseDragEnterPdf(event: any) {
    this.lastenter = event.target;
    if (event.target.className === 'content') {
      $('#dragAndDrop').addClass('uploading');
    }
  }

  public fileDropPdf(event: any, status: any) {
    event.stopPropagation();
    event.preventDefault();
    $('#dragAndDrop').removeClass('uploading');
    let uploadInput;
    if (status) {
      if (event.dataTransfer.items[0].type !== 'image/png' && event.dataTransfer.items[0].type !== 'image/jpeg' && event.dataTransfer.items[0].type !== 'image/jpg') {
        uploadInput = (document.getElementById('uploadSingle') as HTMLInputElement);
        uploadInput.value = '';
        this.toastr.error('Only jpg, jpeg or png format are valid!');
        return;
      }

      if (event.dataTransfer.items) {
        for (let i = 0; i < event.dataTransfer.items.length; i++) {

          if (event.dataTransfer.items[i].getAsFile().size > 5000000) {
            uploadInput = (document.getElementById('uploadSingle') as HTMLInputElement);
            uploadInput.value = '';
            this.toastr.error('File is to big!');
            return;
          }

          this.fileToUpload = event.dataTransfer.items[i].getAsFile();
          this.uploadHeaderImage();
        }
      }
    } else {

      if (event.target.files[0].type !== 'image/png' && event.target.files[0].type !== 'image/jpeg' && event.target.files[0].type !== 'image/jpg') {
        uploadInput = (document.getElementById('uploadSingle') as HTMLInputElement);
        uploadInput.value = '';
        this.toastr.error('Only jpg, jpeg or png format are valid!');
        return;
      }

      if (event.target.files[0].size > 5000000) {
        uploadInput = (document.getElementById('uploadSingle') as HTMLInputElement);
        uploadInput.value = '';
        this.toastr.error('File is to big!');
        return;
      }

      this.fileToUpload = event.srcElement.files[0];
      this.uploadHeaderImage();
    }
  }

  uploadHeaderImage() {
    const self = this;
    setTimeout(function () {
      self.uploadImage?.openUpload(self.fileToUpload);
    }, 100);
  }

  deleteImage() {
    let uploadInput;
    uploadInput = (document.getElementById('uploadSingle') as HTMLInputElement);
    uploadInput.value = '';
    this.coin.logo = null;
  }

  getUploadedImage(event: any) {
    let uploadInput;
    if (!event) {
      uploadInput = (document.getElementById('uploadSingle') as HTMLInputElement);
      uploadInput.value = '';
    } else {
      this.coin.logo = event.croppedImage;
    }
  }


  ngOnDestroy(): void {
    if (this.saveCoin) {
      this.saveCoin.unsubscribe();
    }

    this._document.body.classList.remove('recaptcha');
  }

}
